"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutCms = void 0;
var checkoutConfiguration_cms_1 = require("../components/CheckoutConfigurationContainer/checkoutConfiguration.cms");
var ContactInfoPanel_cms_1 = require("./ContactInfoPanel.cms");
var AddressDetailPanel_cms_1 = require("./AddressDetailPanel.cms");
var DeliveryPanel_cms_1 = require("./DeliveryPanel.cms");
var NumberSelectionPanel_cms_1 = require("./NumberSelectionPanel.cms");
var CreditVerificationPanel_cms_1 = require("./CreditVerificationPanel.cms");
var AccountSecurityPanel_cms_1 = require("./AccountSecurityPanel.cms");
var InstallationPanel_cms_1 = require("./InstallationPanel.cms");
var OrderTermsPanel_cms_1 = require("./OrderTermsPanel.cms");
var PaymentDetailsPanel_cms_1 = require("./PaymentDetailsPanel.cms");
var BillPreferencePanel_cms_1 = require("./BillPreferencePanel.cms");
var CommonFields_cms_1 = require("./CommonFields.cms");
var Common_cms_1 = require("./Common.cms");
var InstallmentBillingPanel_cms_1 = require("../components/panels/InstallmentBillingPanel/InstallmentBillingPanel.cms");
var DeviceTradeInPanel_cms_1 = require("../components/panels/DeviceTradeInPanel/DeviceTradeInPanel.cms");
var OrderSubmit2FAModel_cms_1 = require("../components/cards/OrderSubmit2FAModel/OrderSubmit2FAModel.cms");
var CheckoutCTOModal_cms_1 = require("../components/atoms/CheckoutCTOModal/CheckoutCTOModal.cms");
var AmericanHeartCms_cms_1 = require("../components/panels/DonationOptionalPanel/AmericanHeartCms.cms");
var RedCrossCms_cms_1 = require("../components/panels/DonationOptionalPanel/RedCrossCms.cms");
var CheckoutCms = /** @class */ (function () {
    function CheckoutCms() {
        this.consoleContent = new checkoutConfiguration_cms_1.CheckoutConfigurationCms();
        this.commonFields = new CommonFields_cms_1.CommonFieldsCms();
        this.contactInfoPanel = new ContactInfoPanel_cms_1.ContactInfoPanel();
        this.addressDetailPanel = new AddressDetailPanel_cms_1.AddressDetailsPanel();
        this.deliveryInfoPanel = new DeliveryPanel_cms_1.DeliveryInfoPanel();
        this.numberSelectionPanel = new NumberSelectionPanel_cms_1.NumberSelectionPanel();
        this.creditVerificationPanel = new CreditVerificationPanel_cms_1.CreditVerificationPanel();
        this.accountSecurityPanel = new AccountSecurityPanel_cms_1.AccountSecurityPanel();
        this.installationPanel = new InstallationPanel_cms_1.InstallationPanel();
        this.tncPanel = new OrderTermsPanel_cms_1.OrderTermsPanel();
        this.dueTodayPanel = new PaymentDetailsPanel_cms_1.PaymentDetailsPanel();
        this.billPreferencePanel = new BillPreferencePanel_cms_1.BillPreferencePanel();
        this.installmentBillingPanel = new InstallmentBillingPanel_cms_1.default();
        this.tradeInPanel = new DeviceTradeInPanel_cms_1.DeviceTradeInPanelCMS();
        this.orderSubmit2FAModel = new OrderSubmit2FAModel_cms_1.OrderSubmit2FAModelCMS();
        this.checkoutCTOModal = new CheckoutCTOModal_cms_1.CheckoutCTOModalCms();
        this.americanHeartCms = new AmericanHeartCms_cms_1.AmericanHeartCms();
        this.redCrossCms = new RedCrossCms_cms_1.RedCrossCms();
        this.commonCMS = new Common_cms_1.CommonCms();
    }
    CheckoutCms.prototype.cmstransformer = function (obj) {
        return obj.checkout;
    };
    return CheckoutCms;
}());
exports.CheckoutCms = CheckoutCms;
//# sourceMappingURL=Checkout.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/cms/Checkout.cms.js
// module id = 289
// module chunks = 8